import type { IValueAndUnit } from '@/interfaces'
import CONSTANTS from '@/utils/constants/string-constants'
import {
  INSPECTIONS_URL_NAME,
  ISSUES_URL_NAME,
  JOBS_URL_NAME,
  MAINTENANCE_URL_NAME,
  MESSAGE_CONSTANTS,
  WORK_ORDERS_URL_NAME
} from '../constants'

export const toCamelCase = (pascalCaseObject: Record<string, any>) => {
  const newObject: any = {}
  let newKey
  let value

  if (pascalCaseObject instanceof Array) {
    return pascalCaseObject.map((value) => {
      let temporaryValue = value
      if (typeof value === 'object') {
        temporaryValue = toCamelCase(value)
      }
      return temporaryValue
    })
  }

  Object.keys(pascalCaseObject).forEach((key) => {
    newKey = (key.charAt(0).toLowerCase() + key.slice(1) || key).toString()
    value = pascalCaseObject[key]
    if (value instanceof Array || (value !== null && value.constructor === Object)) {
      value = toCamelCase(value)
    }
    newObject[newKey] = value
  })

  return newObject
}

export const isValidResponse = (status?: number) => {
  if (status && (status / 100 === 2 || status / 100 === 3)) {
    // checks if 2** or 3** response type
    return true
  }
  return false
}

export const getCollapsedString = (str: string, stringLength?: number) => {
  const masStringLen = stringLength || 28
  if (str !== null && str.length > masStringLen) {
    return `${str.substring(0, masStringLen)}...`
  }
  return str
}

export const formatPhoneNumber = (phoneNumber: string) => phoneNumber // todo: format number

export const toSingular = (value?: string) => {
  if (value?.slice(-3) === 'ies') {
    return `${value.slice(0, value.length - 3)}y`
  } else if (value?.endsWith('s')) {
    return `${value.slice(0, -1)}`
  }
  return value
}

export const pluralize = (count: number, item: string) => {
  const lowerCaseItem = item.toLowerCase().trim()

  if (count === 1) {
    if (lowerCaseItem.endsWith('s')) return `${count} ${lowerCaseItem.slice(0, -1)}`
    return `${count} ${lowerCaseItem}`
  }
  if (lowerCaseItem.endsWith('s')) return `${count} ${lowerCaseItem}`
  return `${count} ${lowerCaseItem}s`
}

export const pluralizeWithoutCount = (count: number, item: string) => {
  const lowerCaseItem = item.toLowerCase().trim()

  if (count === 1) {
    if (lowerCaseItem.endsWith('s')) return `${lowerCaseItem.slice(0, -1)}`
    return `${lowerCaseItem}`
  }

  if (lowerCaseItem.endsWith('s')) return `${lowerCaseItem}`
  return `${lowerCaseItem}s`
}

export const apostrophy = (text: string) => {
  if (text.endsWith('s')) return `${text}'`
  return `${text}'s`
}

export const getUpdatedListCount = (total: number, ignored: number) => {
  if (ignored > 0) {
    return total - ignored
  }

  return total
}

export const roundToClosestN = (value: number, maxNumberOfDigitsAfterDecimal = 2) => {
  if (!value) return value
  const numberOfDigitsAfterDecimal = value.toString().split('.')[1]?.length
  if (numberOfDigitsAfterDecimal && numberOfDigitsAfterDecimal > maxNumberOfDigitsAfterDecimal) {
    return +value.toFixed(maxNumberOfDigitsAfterDecimal)
  }
  return +value
}

export const isValidUrl = (url?: string) => {
  if (!url) return false
  return /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s?]+)?(?:\?[^\s]*)?$/.test(
    url
  )
}

export const capitalize = (word: string) => {
  if (!word) return
  return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
}

export const mergeValueAndUnitObject = (item: IValueAndUnit<number>) => {
  return item.value ? `${item.value} ${item.unit}` : CONSTANTS.NOT_ASSIGNED
}

export const toAbsoluteURL = (url: string) => {
  if (url.startsWith('http')) return url
  return `https://${url}`
}

export const getErrorMessageBasedOnRouteURL = () => {
  const url = window.location.pathname
  const path = capitalize(url.split('/')[1])
  console.log(path)
  switch (path) {
    case INSPECTIONS_URL_NAME:
      return MESSAGE_CONSTANTS.INSPECTION_WAS_DELETED_ALERT_MESSAGE
    case ISSUES_URL_NAME:
      return MESSAGE_CONSTANTS.ISSUE_WAS_DELETED_ALERT_MESSAGE
    case MAINTENANCE_URL_NAME:
      return MESSAGE_CONSTANTS.SERVICE_WAS_DELETED_ALERT_MESSAGE
    case WORK_ORDERS_URL_NAME:
      return MESSAGE_CONSTANTS.PURCHASE_ORDER_WAS_DELETED_ALERT_MESSAGE
    case JOBS_URL_NAME:
    default:
      return MESSAGE_CONSTANTS.JOB_WAS_DELETED_ALERT_MESSAGE
  }
}
